<ion-content class="ion-padding" color="light">
  <ion-range
    min="1" max="60"
    snaps="true" 
    step="1"
    ticks="true" 
    color="primary"
    [value]="match.scoreDelay"
    (ionChange)="scoreDelay = $event.detail.value">
  </ion-range>
  <ion-label>{{'Score emit delay' | translate}}: {{ scoreDelay }}</ion-label>

  <ion-button (click)="updateScoreDelay()" expand="block" fill="clear" shape="round">
    {{'Update' | translate}}
  </ion-button>

  <ion-card>
    <ion-card-content>
      <p><strong>{{'Suggested delays' | translate}}:</strong></p>
      {{'Default use' | translate}}: 3-5"<br />
      {{'Video Stream' | translate}}: 1-2"<br />
      {{'ITF/Pro events' | translate}}: 30-60"
    </ion-card-content>
  </ion-card>

</ion-content>